import { Dictionary, SerializableObject } from '../../core';

// TODO: Implement BaseReportDefinition and various report type definitions.
export type AccountReport = object;
export type SalesReport = object;
export type SalesLineReport = object;

/**
 * A container for Report definitions.
 */
export class ReportDefinition extends SerializableObject {
  /**
   * Contains all Account reports.
   */
  public AccountReports: Dictionary<AccountReport>;

  /**
   * Contains all Sales reports.
   */
  public SalesReports: Dictionary<SalesReport>;

  /**
   * Contains all Sales Line reports.
   */
  public SalesLineReports: Dictionary<SalesLineReport>;
}
